export enum MediaType {
  IMAGE = "image",
  VIDEO = "video",
}
